import React from "react";
import { useMediaQuery } from "@mui/material";

const WarningPage: React.FC = () => {
  const isSmallScreen = useMediaQuery("(max-width:650px)");

  const imageSrc = isSmallScreen
    ? "/bg-warning-mobile.png" // imagem alternativa para telas pequenas
    : "bg-warning-desktop.png"; // imagem padrão

  return (
    <div
      style={{
        width: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        overflowY: "auto",
      }}
    >
      <img
        src={imageSrc}
        alt="Alerta ITOP TELECOM"
        style={{
          width: "100%",
          height: "auto",
          display: "block",
        }}
      />
    </div>
  );
};

export default WarningPage;
